import { ca } from '@cian/analytics';

interface ITrackingParams {
  offerId: number;
  mlSearchSessionGuid: string | null;
  source?: string;
}

/**
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1469163170
 * Событие №1
 */
export const trackClickOnBookedShowMoreButton = ({ offerId, mlSearchSessionGuid, source }: ITrackingParams) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'Listing',
    label: 'booked_similar_offers',
    page: {
      extra: {
        mlSearchSessionGuid,
        source,
      },
    },
    products: [
      {
        id: offerId,
      },
    ],
  });
};

/**
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1469163170
 * Событие №1
 */
export const trackShowBookedShowMoreButton = ({ offerId, mlSearchSessionGuid, source }: ITrackingParams) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'show_sopr',
    category: 'Listing',
    label: 'booked_similar_offers',
    page: {
      extra: {
        mlSearchSessionGuid,
        source,
      },
    },
    products: [
      {
        id: offerId,
      },
    ],
  });
};
